import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { NamingConvention } from "@mipro/classes/naming-convention";
import { NamingConventionService } from "@mipro/services/naming-convention.service";
import { Subscription } from "rxjs";

@Component({
    selector: "naming-convention-label",
    template: `
        <ng-container>
            {{ label }}
        </ng-container>
    `
})
export class NamingConventionLabelComponent implements OnDestroy, OnInit {
    private subs: Subscription;

    label = "";

    updateLabel() {
        switch(this.type) {

            case "EndUser":
                this.label = this.singular ? this.namingConventionService.endUserSingular : this.namingConventionService.endUserPlural;
            break;

            case "Group":
                this.label =this.singular ?  this.namingConventionService.groupSingular : this.namingConventionService.groupPlural;
            break;

            case "Org":
                this.label =this.singular ?  this.namingConventionService.organisationSingular : this.namingConventionService.organisationPlural;
            break;
        }
        this.label = this.capitalize ? this.label : this.label.toLowerCase();
        this.label = this.uppercase ? this.label.toUpperCase():this.label;
    }

    @Input()
    public singular: boolean;
    @Input()
    public capitalize: boolean = true;

    @Input()
    public uppercase: boolean = false;
    
    @Input()
    type: "EndUser" | "Group" | "Org"  = "EndUser";

    constructor(public namingConventionService: NamingConventionService, public broadcastService: BroadcastService) {
        this.subs = this.broadcastService
            .on<NamingConvention>(NamingConventionService.NamingConventionUpdatedEventName)
            .subscribe(_ => this.updateLabel());
    }

    ngOnDestroy(): void {
        this.subs?.unsubscribe();
    }

    ngOnInit(): void {
        this.updateLabel();
    }
}
